export const ASYNC_CREATE_ACTION = 'ASYNC_CREATE_ACTION';
export const ASYNC_EDIT_ACTION = 'ASYNC_EDIT_ACTION';
export const ASYNC_CHANGE_STATUS_ACTION = 'ASYNC_CHANGE_STATUS_ACTION';
export const ASYNC_CHANGE_STATUS_ACTION_CREATIVE =
  'ASYNC_CHANGE_STATUS_ACTION_CREATIVE';
export const ASYNC_EDIT_ACTION_CREATIVE = 'ASYNC_EDIT_ACTION_CREATIVE';
export const ASYNC_CREATE_COMPROVATION = 'ASYNC_CREATE_COMPROVATION';
export const ASYNC_COMPROVATION_APPROVAL = 'ASYNC_COMPROVATION_APPROVAL';
